import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { Flex, useBreakpoint } from '@servicetitan/anvil2';

import { BREAKPOINTS_SMALLER_LG } from '../../utils/ux';

import * as Styles from './configuration-helpers.module.less';

export const ActiveFieldsSection: FC<PropsWithChildren> = ({ children }) => {
    const breakpoint = useBreakpoint();

    return (
        <Flex
            direction="column"
            grow={1}
            gap={6}
            basis={0}
            lg={{ alignSelf: 'flex-start' }}
            className={classNames(Styles.activeFieldsSection, {
                [Styles.activeFieldsSectionLimitedWidth]: !BREAKPOINTS_SMALLER_LG.includes(
                    breakpoint?.name ?? '',
                ),
            })}
        >
            {children}
        </Flex>
    );
};
